import { TRIGGERS_CORE } from '@/triggers/registry-core'
import type { TriggerConfig, TriggerRegistry } from '@/triggers/types'

/**
 * Every trigger by id, seeded with the core set and extended in place when the
 * integration catalogue lands. Readers index it on every call.
 */
export const TRIGGER_REGISTRY: TriggerRegistry = { ...TRIGGERS_CORE }

/** Adds the catalogue's entries; the loader calls this exactly once. */
export function extendTriggerRegistry(triggers: Record<string, TriggerConfig>): void {
  Object.assign(TRIGGER_REGISTRY, triggers)
}
